export enum EntityType {
  FRAME = 'FRAME',
  LINKED_ASSET = 'LINKED_ASSET',
  LINKED_ASSET_FRAME = 'LINKED_ASSET_FRAME',
}

export enum DraftErrorType {
  MISSING_DATA = 'MISSING_DATA',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  SSP_VALIDATION_ERROR = 'SSP_VALIDATION_ERROR',
  APPLICATION_ERROR = 'APPLICATION_ERROR',
}
